import { ChartLegend } from "./ChartLegend";

/** 차트 카드 헤더 — 제목/부제 + 우측 범례 (범례 hover 는 owner 가 focusedCode 로 동기) */
export function ChartCardHeader({
  title,
  subtitle,
  series,
  focusEnabled = true,
  focusedCode,
  onHover,
}: {
  title: string;
  subtitle?: string;
  series: { code: string; name: string; color: string }[];
  focusEnabled?: boolean;
  focusedCode: string | null;
  onHover: (code: string | null) => void;
}) {
  return (
    <div className="card-hd chart-card-hd">
      <div className="chart-card-hd-text">
        <div className="card-title">{title}</div>
        {subtitle && <div className="card-sub">{subtitle}</div>}
      </div>
      <ChartLegend
        items={series.map((s) => ({ code: s.code, name: s.name, color: s.color }))}
        focusedCode={focusedCode}
        onHover={onHover}
        focusEnabled={focusEnabled}
      />
    </div>
  );
}
